<template>
  <workOrderProcess/>
</template>
<script>
import WorkOrderProcess from 'operations/workorder/workOrderProcess.vue'
export default {
    components:{
      WorkOrderProcess
    }
}
</script>